
/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  homes.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/7/4 14:44
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from "./indexORC";

/**
*  身份证OCR识别
* @param params
*/
export function getIDCardByOCR(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/getIDCardByOCR',
    method: 'get',
    params: Parameter,
    extraParams: {showLoading: false}
  })
}
/**
 *  保存/更新身份信息
 * @param params
 */
export function addIDCard(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/addIDCard',
    method: 'post',
    data: Parameter
  })
}

/**
* 实名认证调取活体检测
* @param params
*/
export function brushFaceByIDCard(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/brushFaceByIDCard',
    method: 'post',
    data: Parameter,
    extraParams: {showLoading: false}
  })
}
// getCompanyInfo
/**
* 获取企业信息
* @param params
*/
export function getCompanyInfo(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyQuery/getCompanyInfo',
    method: 'post',
    data: Parameter
  })
}
// getIDCard
/**
* 获取企业信息
* @param params
*/
export function getIDCard(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/getIDCard',
    method: 'get',
    params: Parameter
  })
}
// getBHCreditReport
/**
* 查询百行征信
* @param params
*/
export function getBHCreditReport(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/getTYCCreditReport',
    method: 'post',
    data: Parameter,
    extraParams: {showLoading: false}
  })
}

export function getOutDataShuZhunBaoV3(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreFinance/FDA/getOutDataShuZhunBaoV3',
    method: 'post',
    headers: {
      'toastTip': 'no'
    },
    data: Parameter,
    extraParams: {showLoading: false}
  })
}
